import { useMemo } from 'react'

import { useParams } from 'react-router'

import { ResourceNotFound } from '@/components/ui/ResourceNotFound'
import { TaskListPage } from '@/modules/tasks/components/task-list-page'
import { TaskModule } from '@/modules/tasks/task-module'

export const TaskListView = () => {
  const { id: rawId } = useParams()
  const id = useMemo(() => (rawId ? Number.parseInt(rawId) : null), [rawId])

  if (id == null) {
    return <ResourceNotFound />
  }

  return (
    <TaskModule disableFetch>
      <TaskListPage id={id} />
    </TaskModule>
  )
}
